/**
 * Feature flags -- controls which modules are visible in the UI.
 * Backend endpoints remain functional for API consumers.
 */
export const FEATURE_FLAGS = {
  customers: false, // Hidden -- data comes from Raynet via orders
  routeMap: false, // Hidden -- future feature
  workLogs: false, // Hidden -- hours tab is disabled for all user groups
  tasks: false, // Hidden -- tasks tab is disabled for all user groups
  chat: false, // Hidden -- future feature
  payroll: false, // Hidden -- Phase 2, after orders workflow proven
  statistics: true,
  profitability: false, // Removed -- belongs in CRM (Raynet)
  reportPhotos: import.meta.env.VITE_FEATURE_REPORT_PHOTOS === "true",
  ksenaAi: import.meta.env.VITE_FEATURE_KSENA_AI === "true", // Hidden until enabled per deployment (also needs backend AI_ENABLED)
  attendance: import.meta.env.VITE_FEATURE_ATTENDANCE === "true", // Hidden -- managers' attendance, waiting for client approval
} as const;
